import BereavedPersonCard from './BereavedPersonCard';

export default BereavedPersonCard;
